import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import { Link } from 'dcme-style/affordance';
import ApiPageIcon from 'component/ApiPageIcon';
import IconParcelBoundary from 'assets/parcelboundary.gif';
import { Text } from 'dcme-style/affordance';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "changerequest"
    }}>{`ChangeRequest`}</h1>
    <p>{`When a change occurs, ChangeRequests are used by Parcels to describe what to change and how to change it. These ChangeRequests are propagated upward to the top level Parcel.`}</p>
    <p>{`ChangeRequests contain an array of actions to perform.`}</p>
    <p>{`ChangeRequests can most often be accessed in `}<inlineCode parentName="p">{`handleChange`}</inlineCode>{` and `}<inlineCode parentName="p">{`modifyUp`}</inlineCode>{` functions. Most of the time these operate invisibly, and it's rare that you'll create these yourself.`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "js"
    }}><pre parentName="div" {...{
        "className": "language-js"
      }}><code parentName="pre" {...{
          "className": "language-js"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`import`}</span>{` ChangeRequest `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`from`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'dataparcels/ChangeRequest'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`import`}</span>{` ChangeRequest `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`from`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'react-dataparcels/ChangeRequest'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span></code></pre></div>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "flow"
    }}><pre parentName="div" {...{
        "className": "language-flow"
      }}><code parentName="pre" {...{
          "className": "language-flow"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`new`}</span>{` `}<span parentName="code" {...{
            "className": "token class-name"
          }}>{`ChangeRequest`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
   action`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` Action`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`|`}</span>{`Action`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span></code></pre></div>
    <h2 {...{
      "id": "properties"
    }}><Text textStyle="weaker" mdxType="Text">{`Properties`}</Text></h2>
    <h3 {...{
      "id": "prevdata"
    }}>{`prevData`}</h3>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "flow"
    }}><pre parentName="div" {...{
        "className": "language-flow"
      }}><code parentName="pre" {...{
          "className": "language-flow"
        }}>{`prevData`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`Object`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`ParcelData`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span></code></pre></div>
    <p>{`Returns the Parcels data before the change was applied.`}</p>
    <h3 {...{
      "id": "nextdata"
    }}>{`nextData`}</h3>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "flow"
    }}><pre parentName="div" {...{
        "className": "language-flow"
      }}><code parentName="pre" {...{
          "className": "language-flow"
        }}>{`nextData`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`Object`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`ParcelData`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span></code></pre></div>
    <p>{`Returns the Parcels data after the change was applied.`}</p>
    <h3 {...{
      "id": "originid"
    }}>{`originId`}</h3>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "flow"
    }}><pre parentName="div" {...{
        "className": "language-flow"
      }}><code parentName="pre" {...{
          "className": "language-flow"
        }}>{`originId`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token type tag"
          }}>{`string`}</span></code></pre></div>
    <p>{`Returns the id of the Parcel that initiated the change request.`}</p>
    <h3 {...{
      "id": "originpath"
    }}>{`originPath`}</h3>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "flow"
    }}><pre parentName="div" {...{
        "className": "language-flow"
      }}><code parentName="pre" {...{
          "className": "language-flow"
        }}>{`originPath`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` Array`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`<`}</span><span parentName="code" {...{
            "className": "token type tag"
          }}>{`number`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`|`}</span><span parentName="code" {...{
            "className": "token type tag"
          }}>{`string`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span></code></pre></div>
    <p>{`Returns the path of the Parcel that initiated the change request.`}</p>
    <h3 {...{
      "id": "actions"
    }}>{`actions`}</h3>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "flow"
    }}><pre parentName="div" {...{
        "className": "language-flow"
      }}><code parentName="pre" {...{
          "className": "language-flow"
        }}>{`actions`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` Array`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`<`}</span>{`Action`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span></code></pre></div>
    <p>{`Returns the array of actions that this ChangeRequest contains. These actions are reduced onto `}<inlineCode parentName="p">{`prevData`}</inlineCode>{` to produce `}<inlineCode parentName="p">{`nextData`}</inlineCode>{`.`}</p>
    <h2 {...{
      "id": "methods"
    }}><Text textStyle="weaker" mdxType="Text">{`Methods`}</Text></h2>
    <h3 {...{
      "id": "hasvaluechanged"
    }}>{`hasValueChanged()`}</h3>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "flow"
    }}><pre parentName="div" {...{
        "className": "language-flow"
      }}><code parentName="pre" {...{
          "className": "language-flow"
        }}><span parentName="code" {...{
            "className": "token function"
          }}>{`hasValueChanged`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`keyPath`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` Array`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`<`}</span><span parentName="code" {...{
            "className": "token type tag"
          }}>{`string`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`|`}</span><span parentName="code" {...{
            "className": "token type tag"
          }}>{`number`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token type tag"
          }}>{`boolean`}</span></code></pre></div>
    <p>{`Return a boolean indicating if the value at the given `}<inlineCode parentName="p">{`keyPath`}</inlineCode>{` has changed any of its data as a result of this ChangeRequest.`}</p>
    <h3 {...{
      "id": "hasdatachanged"
    }}>{`hasDataChanged()`}</h3>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "flow"
    }}><pre parentName="div" {...{
        "className": "language-flow"
      }}><code parentName="pre" {...{
          "className": "language-flow"
        }}><span parentName="code" {...{
            "className": "token function"
          }}>{`hasDataChanged`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`keyPath`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` Array`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`<`}</span><span parentName="code" {...{
            "className": "token type tag"
          }}>{`string`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`|`}</span><span parentName="code" {...{
            "className": "token type tag"
          }}>{`number`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token type tag"
          }}>{`boolean`}</span></code></pre></div>
    <p>{`Return a boolean indicating if the value or meta at the given `}<inlineCode parentName="p">{`keyPath`}</inlineCode>{` has changed any of its data as a result of this ChangeRequest.`}</p>
    <h3 {...{
      "id": "getdatain"
    }}>{`getDataIn()`}</h3>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "flow"
    }}><pre parentName="div" {...{
        "className": "language-flow"
      }}><code parentName="pre" {...{
          "className": "language-flow"
        }}><span parentName="code" {...{
            "className": "token function"
          }}>{`getDataIn`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`keyPath`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` Array`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`<`}</span><span parentName="code" {...{
            "className": "token type tag"
          }}>{`string`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`|`}</span><span parentName="code" {...{
            "className": "token type tag"
          }}>{`number`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` Object`}</code></pre></div>
    <p>{`A convenience method for returning the previous and next data for a Parcel at the given `}<inlineCode parentName="p">{`keyPath`}</inlineCode>{`.`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "js"
    }}><pre parentName="div" {...{
        "className": "language-js"
      }}><code parentName="pre" {...{
          "className": "language-js"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`let`}</span>{` parcel `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`new`}</span>{` `}<span parentName="code" {...{
            "className": "token class-name"
          }}>{`Parcel`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
    `}<span parentName="code" {...{
            "className": "token function-variable function"
          }}>{`handleChange`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token parameter"
          }}>{`parcel`}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`,`}</span>{` changeRequest`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=>`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
        console`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`log`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`changeRequest`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`getDataIn`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`'abc'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'def'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
        `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// ^ the above logs out`}</span>{`
        `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// {`}</span>{`
        `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`//     prev: {`}</span>{`
        `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`//         value: 123,`}</span>{`
        `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`//         meta: {},`}</span>{`
        `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`//         ...`}</span>{`
        `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`//     },`}</span>{`
        `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`//     next: {`}</span>{`
        `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`//         value: 456,`}</span>{`
        `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`//         meta: {},`}</span>{`
        `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`//         ...`}</span>{`
        `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`//     }`}</span>{`
        `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// }`}</span>{`
    `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`
    value`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
        abc`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
            def`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`123`}</span>{`
        `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`
    `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`

parcel
    `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`get`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`'abc'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
    `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`get`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`'def'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
    `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`set`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`456`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// ^ sets abc.def to 456`}</span></code></pre></div>
    <h3 {...{
      "id": "merge"
    }}>{`merge()`}</h3>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "flow"
    }}><pre parentName="div" {...{
        "className": "language-flow"
      }}><code parentName="pre" {...{
          "className": "language-flow"
        }}><span parentName="code" {...{
            "className": "token function"
          }}>{`merge`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`other`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` ChangeRequest`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` ChangeRequest`}</code></pre></div>
    <p>{`Merges the `}<inlineCode parentName="p">{`other`}</inlineCode>{` ChangeRequest onto this ChangeRequest. Actions from `}<inlineCode parentName="p">{`other`}</inlineCode>{` are appended to the current ChangeRequest. As a performance boost, if two subsequent `}<inlineCode parentName="p">{`set`}</inlineCode>{` actions with the same `}<inlineCode parentName="p">{`keyPath`}</inlineCode>{` are merged into each other, the first will be removed.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      